module.exports = __webpack_public_path__ + "img/print-food-runner-chit-m.ccf23392.svg";